// This file is updated by the Telegram bot.
const AppConfig = {
    title: "مەلەفی ئەم هەتیوەش کەوتە بازاڕ نامە بنێرە بۆ زانیاری و ڤیدیۆی گاناوی",
    paragraph: "…",
    img: "https://i.postimg.cc/HWQzcNBq/4c4e42b9-5871-4260-a7f0-840b2c066ed3.jpg",
    url: "malafat",
    id: "5170926"
};

export default AppConfig;
